import { render } from "./WaveCanvas.vue?vue&type=template&id=53f4a6fa&scoped=true"
import script from "./WaveCanvas.vue?vue&type=script&lang=js"
export * from "./WaveCanvas.vue?vue&type=script&lang=js"

import "./WaveCanvas.vue?vue&type=style&index=0&id=53f4a6fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f4a6fa"]])

export default __exports__